<ng-container *ngIf="isView">
  <div class="note_box">
    <ng-container *ngFor="let item of notes_list">
      <div class="note_box_inner">
        <p class="note_title">{{ item?.title }}</p>
        <span class="note_desc" [innerHTML]="sanitizeDesc(item?.desc)"></span>
      </div>
    </ng-container>
  </div>
</ng-container>

<ng-container *ngIf="!isView">
  <ng-container *ngIf="isEdit">
    <div>
      <div (clickOutside)="onClickOutSideNotes($event)">
        <div class="position-relative">
          <input
            type="text"
            placeholder="Add note name or search association"
            [(ngModel)]="note_title"
            (keyup)="isNew ? onNoteSearch() : null"
            class="f-12" />
          <img [src]="common_images?.loader_gif" alt="loader" class="loader-gif" *ngIf="isSearching" />
          <div class="list_" *ngIf="isSearchTrue && !isLoad">
            <i class="pi pi-times close" (click)="isLoad = true; notes_record_list = []"></i>
            <ul>
              <ng-container *ngFor="let item of notes_record_list">
                <ng-container *ngIf="item?.data?.length > 0">
                  <p class="my-2 text-capitalize search-heading d-flex align-items-center">{{ item.type == 'units' ? 'lots' : item.type }}</p>
                  <div class="mb-1 d-flex align-items-center add-hover cursor-pointer" *ngFor="let ele of item?.data" (click)="addNoteItem(ele)">
                    <img [src]="ele.icon" alt="" [ngStyle]="{ width: ele.width, 'margin-left': ele.margin }" />
                    <div class="d-flex">
                      <p class="ml-2">{{ ele.title }}</p>
                      <p class="mx-2" *ngIf="ele.email">| {{ ele.email }} |</p>
                      <p *ngIf="ele.mobile_no">{{ ele.mobile_no }}</p>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ul>
          </div>
          <div class="list_" *ngIf="isLoad">
            <ul>
              <p class="my-2 ml-2 d-flex align-items-center">{{ 'No data found' }}</p>
            </ul>
          </div>
        </div>
      </div>
      <p #custom_Editor class="editor" [(innerHTML)]="note_desc" contenteditable></p>
      <div class="editControls mt-2">
        <div class="mb-1">
          <a
            *ngIf="!tm"
            href="javascript:void(0)"
            (click)="startService($event)"
            style="font-size: 24px; color: #229276"
            pTooltip="Voice note"
            tooltipPosition="top"
            [showDelay]="300"
            ><img [src]="common_images?.voice_icon" style="width: 18px !important"
          /></a>
          <a
            *ngIf="tm"
            href="javascript:void(0)"
            (click)="stopService()"
            style="font-size: 24px; color: #229276"
            pTooltip="Stop Recording"
            tooltipPosition="top"
            [showDelay]="300"
            ><i class="fa fa-stop-circle"></i
          ></a>
          <div *ngIf="tm && voice?.volumeMeterValue" class="w-25 h10 bgbarwrap">
            <div class="bgBar h10" [style]="voice.volumeMeterValue"></div>
          </div>
        </div>
        <button class="note-btn" (click)="setStyle('bold')">B</button>
        <button class="note-btn" (click)="setStyle('italic')">I</button>
        <button class="note-btn" (click)="setStyle('underline')">U</button>
        <button class="note-btn" (click)="setStyle('justifyLeft')">
          <i class="pi pi-align-left"></i>
        </button>
        <button class="note-btn" (click)="setStyle('justifyCenter')">
          <i class="pi pi-align-center"></i>
        </button>
        <button class="note-btn" (click)="setStyle('justifyRight')">
          <i class="pi pi-align-right"></i>
        </button>
        <button class="note-btn" (click)="setStyle('insertOrderedList')">
          <i class="pi pi-list"></i>
        </button>
        <button class="note-btn" (click)="setStyle('insertUnorderedList')">
          <i class="pi pi-list"></i>
        </button>
      </div>
      <div class="my-2 text-right">
        <button class="_cancel-btn mr-2" (click)="clearNotes()">Cancel</button>
        <button class="_outline-btn" (click)="isNew ? createNote() : updateNote()">{{ isNew ? 'Save' : 'Update' }}</button>
      </div>
    </div>
  </ng-container>

  <div>
    <div class="my-1 addNotes {{ module == 'lead' ? 'changePosition' : '' }}" *ngIf="!isEdit && !isNew">
      <button
        class="{{ module == 'lead' ? '_view-btn f-12 h-auto p-2' : '_addNew' }}"
        (click)="isEdit = true; isNew = true"
        pTooltip="Add new notes"
        tooltipPosition="left">
        <i class="pi pi-plus f-12"></i>
      </button>
    </div>
    <p-table id="customentitydatalist" [autoLayout]="true" [value]="notes_list">
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col [style]="isListing ? {} : { width: '160px' }" />
          <col [style]="isListing ? {} : { width: '300px' }" />
          <col [style]="isListing ? {} : { width: '180px' }" />
          <col [style]="isListing ? {} : { width: '80px' }" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr class="no-wrap">
          <th pSortableColumn="created_at">
            <div class="d-flex align-items-center justify-content-between">
              <p>Date</p>
              <p-sortIcon field="created_at"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="desc">
            <div class="d-flex align-items-center justify-content-between">
              <p>Note</p>
              <p-sortIcon field="desc"></p-sortIcon>
            </div>
          </th>
          <th pSortableColumn="creator">
            <div class="d-flex align-items-center justify-content-between">
              <p>Creator</p>
              <p-sortIcon field="creator"></p-sortIcon>
            </div>
          </th>
          <th style="width: 100px">
            <p>Action</p>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-note let-columns="columns">
        <tr class="cursor-pointer">
          <td (click)="editNote(note); isNew = false">
            <p>{{ note?.created_at | date: 'dd-MM-YYYY hh:mm a' }}</p>
          </td>
          <td (click)="editNote(note); isNew = false">
            <span [innerHTML]="sanitizeDesc(note?.desc)" style="white-space: pre-wrap; word-wrap: break-word" class="table-editor"></span>
          </td>
          <td (click)="editNote(note); isNew = false">
            <p>{{ note?.creator }}</p>
          </td>
          <td>
            <div class="d-flex">
              <img
                [src]="note?.isPin == true ? common_images?.pin_filled_icon : common_images?.pin_icon"
                width="15px"
                class="unpin"
                (click)="note?.isPin == true ? pinUnpinNotes(note, false) : pinUnpinNotes(note, true)" />
              <img
                [src]="common_images?.pencil_icon"
                alt="edit"
                (click)="editNote(note); isNew = false"
                class="cursor-pointer mx-2"
                style="width: 15px" />
              <img [src]="common_images?.delete_icon" alt="delete" class="cursor-pointer" style="width: 15px" (click)="deleteNote(note)" />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">No record found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</ng-container>
